
// This JS partial relies on the JS plugin jquery-qrcode.min.js

function productVtoOverlay() {

  // Define VTO host
  var vtoHostRoot = "https://try-on.chupi.com/";

  // Create VTO Product link
  var productHandle = $('#product-top').attr('data-product-handle');
  var currency = $('body').attr('data-currency');
  var vtoLink = vtoHostRoot + '?product=' + productHandle + '&currency=' + currency;
  var qrGenerated = false;
  let overlayImageLoaded = false;

  $('#vto-btn').click(function(e) {
    if( window.innerWidth > desktopBreakPoint ) {
      // Prevent link opening, open VTO QR modal instead (desktop)
      e.preventDefault();
      // Create QR code (once only)
      if (qrGenerated == false) {
        // Ref: https://www.jqueryscript.net/other/qr-code-logo-label.html
        $("#vto-qr").qrcode({
          render: 'canvas',
          text: vtoLink,
          // label: 'test label',
          mode: 0, // normal
          // mode: 1, // label strip
          // mode: 2, // label boox
          // mode: 3, // image  strip
          // mode: 4, // image box
          //image: centreImage,
          size: 150,
          //mSize: 0.4, // image size with QR box
          ecLevel: 'L'
        });
        qrGenerated = true;
      }
      // Manually lazy load overlay image on first open only
      if(overlayImageLoaded == false) {
        let overlayImage = $('#vto-qr-overlay').find('img[data-src-manual]');
        overlayImage.attr('src', overlayImage.attr('data-src-manual'));
        overlayImage.on('load', () => {
          overlayImage.removeClass('loading');
        });
        overlayImageLoaded = true;
      }
      // Open VTO QR overlay
      $('#vto-qr-overlay').addClass('active');
      handleFixedElements('hide');
    }
  });


  // Copy QR link
  function copyLink(target) {
    var vtoLink = target.attr('data-vto-link');
    var el = document.createElement('textarea');
    el.value = vtoLink;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }

  $('#vto-qr-overlay').find('.copy-link').click(function() {
    var thisCopyLink = $(this);
    thisCopyLink.addClass('copied');
    setTimeout( function() {
      thisCopyLink.removeClass('copied');
    }, 2000);
    copyLink(thisCopyLink);
  });

}


if ($('#vto-qr-overlay').length) {
  productVtoOverlay();
}
